/** Money is held as integer US cents everywhere; floats never touch a price. */
export type Cents = number;

export const cents = (dollars: number): Cents => Math.round(dollars * 100);

/**
 * "$4", "$0.50", "$4.69", "$348". Whole dollars drop the cents unless `alwaysCents` is set, which
 * line items and invoices use so a column of amounts lines up ("$1.00", "$2.50").
 */
export function formatMoney(amount: Cents, options: { alwaysCents?: boolean } = {}): string {
  const negative = amount < 0;
  const abs = Math.abs(amount);
  const dollars = Math.floor(abs / 100);
  const rest = abs % 100;
  const whole = dollars.toLocaleString("en-US");
  const text =
    rest === 0 && !options.alwaysCents ? `$${whole}` : `$${whole}.${String(rest).padStart(2, "0")}`;
  return negative ? `-${text}` : text;
}
